import { useMutation } from "@tanstack/react-query";
import { postHprAadhaarMobileVerify } from "apis";

const usePostHprMobileVerify = () => {
  return useMutation(postHprAadhaarMobileVerify);
};

export default usePostHprMobileVerify;
